import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './FixedPriceToggle.module.css'
import styleNames from '../../utils/styleNames'
import classNames from 'classnames'
import ToggleButton from '../ToggleButton/ToggleButton'

export default class FixedPriceToggle extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    estimateLoading: PropTypes.bool,
    onChange: PropTypes.func
  }

  render () {
    const containerClasses = classNames('fixed-price-toggle', {
      loading: this.props.estimateLoading
    })    
    return (
      <div className={styleNames(styles, containerClasses)}>
      	<h2>Fastpris</h2>
        <ToggleButton 
          checked={this.props.checked}
          name="fixed-price"
          onChange={this.props.onChange} 
        />  
      </div>
    )
  }
}
